export default "__VITE_ASSET__DpMi07ie__"